import React from 'react'
import { Paper, Box, Typography } from '@material-ui/core'
import '../../index.css'

export default function Card(props: { title: string; children?: any; elevation?: number; className?: string }) {
  const { elevation, className, children, title } = props
  return (
    <Paper className='card' elevation={elevation}>
      <Box className={'cardBorder ' + className}>
        <Box className='cardTitle'>
          <Typography variant='h5'>{title}</Typography>
        </Box>
        <Box className={'cardContent'}>{children}</Box>
      </Box>
    </Paper>
  )
}
